import { Flex, Image, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface IAnimationItem {
	image: string;
	header: string;
	text: string;
}

export const AnimationItem: FC<IAnimationItem> = ({ image, header, text }) => {
	return (
		<Flex
			flexDir="column"
			align="center"
			gridGap="20px"
			zIndex="4"
		>
			<Text
				fontSize="40px"
				fontWeight="bold"
			>
				{header}
			</Text>
			<Text>{text}</Text>
			<Flex
				h="300px"
				pos="relative"
				align="center"
				mt="10px"
			>
				<Image
					maxH="100%"
					src={image}
				/>
			</Flex>
		</Flex>
	);
};
